export const cartasInspiradorasMock = [
  {
    id: 1,
    autor: "M.S.",
    cidade: "São Paulo, SP",
    data: "15 de março de 2024",
    categoria: "superacao",
    trecho: "Quando você ler esta carta, espero que tenha superado todos os medos que hoje te paralisam. Lembre-se: você é mais forte do que imagina. Aquela promoção que tanto sonha? Você conseguiu. Aquele medo de falar em público? Você venceu. Cada pequeno passo que der hoje será uma vitória gigante amanhã.",
    likes: 847,
    tags: ["Superação", "Carreira", "Autoconfiança"]
  },
  {
    id: 2,
    autor: "Anônimo",
    cidade: "Rio de Janeiro, RJ",
    data: "22 de janeiro de 2024",
    categoria: "amor-proprio",
    trecho: "Eu do futuro, espero que você tenha aprendido a se amar de verdade. Que olhe no espelho e veja beleza, não defeitos. Que celebre suas conquistas, por menores que sejam. Você merece todo o amor que dá aos outros. Nunca esqueça disso.",
    likes: 1203,
    tags: ["Amor-próprio", "Autoestima", "Bem-estar"]
  },
  {
    id: 3,
    autor: "Carlos E.",
    cidade: "Belo Horizonte, MG",
    data: "8 de fevereiro de 2024",
    categoria: "saude-mental",
    trecho: "Hoje acordei e pela primeira vez em anos não senti aquele peso no peito. A terapia funcionou. Os remédios ajudaram. Mas foi você, eu do passado, que teve coragem de pedir ajuda. Obrigado por não desistir nos dias mais escuros. A luz voltou.",
    likes: 2156,
    tags: ["Saúde Mental", "Depressão", "Esperança"]
  },
  {
    id: 4,
    autor: "Ana B.",
    cidade: "Curitiba, PR",
    data: "30 de dezembro de 2023",
    categoria: "familia",
    trecho: "Mãe, se você está lendo isso, conseguimos. Aquela conversa difícil que você tanto adiava aconteceu. E sabe o que descobri? Ela sempre soube. Sempre amou você do jeito que você é. O medo era só seu. A família está mais unida do que nunca.",
    likes: 956,
    tags: ["Família", "Aceitação", "Amor"]
  },
  {
    id: 5,
    autor: "R.L.",
    cidade: "Porto Alegre, RS",
    data: "14 de abril de 2024",
    categoria: "carreira",
    trecho: "Você largou aquele emprego que te destruía. Sim, foi assustador. Sim, teve noites sem dormir. Mas hoje você trabalha com o que ama, acorda feliz e ganha o dobro. Confiar em si mesmo foi a melhor decisão que você já tomou.",
    likes: 1432,
    tags: ["Carreira", "Mudança", "Coragem"]
  },
  {
    id: 6,
    autor: "Fernanda M.",
    cidade: "Brasília, DF",
    data: "5 de março de 2024",
    categoria: "superacao",
    trecho: "Eu do passado, você não vai acreditar: você correu uma maratona! Sim, você que mal conseguia subir escadas sem perder o fôlego. Perdeu 30kg, ganhou saúde e descobriu que seu corpo é capaz de coisas incríveis quando você acredita nele.",
    likes: 1789,
    tags: ["Superação", "Saúde", "Transformação"]
  },
  {
    id: 7,
    autor: "J.P.",
    cidade: "Recife, PE",
    data: "18 de fevereiro de 2024",
    categoria: "amor-proprio",
    trecho: "Hoje olhei para trás e vi quanto tempo desperdicei tentando agradar pessoas que não me valorizavam. Agora estou cercado de quem realmente importa. Aprendi que dizer 'não' não é egoísmo, é autocuidado. E minha paz mental agradece.",
    likes: 1124,
    tags: ["Amor-próprio", "Limites", "Relacionamentos"]
  },
  {
    id: 8,
    autor: "Mariana S.",
    cidade: "Salvador, BA",
    data: "25 de janeiro de 2024",
    categoria: "saude-mental",
    trecho: "As crises de ansiedade pararam. Não foi da noite para o dia, mas aconteceu. Você aprendeu a respirar, a meditar, a pedir ajuda. Hoje você ensina outras pessoas a fazerem o mesmo. Sua dor virou propósito.",
    likes: 2341,
    tags: ["Saúde Mental", "Ansiedade", "Propósito"]
  },
  {
    id: 9,
    autor: "Anônimo",
    cidade: "Fortaleza, CE",
    data: "10 de março de 2024",
    categoria: "familia",
    trecho: "Pai, você finalmente disse 'eu te amo' para seus filhos. Quebrou o ciclo de frieza emocional que vinha de gerações. Seus filhos crescerão sabendo que são amados. E você descobriu que demonstrar afeto não te faz menos homem, te faz mais humano.",
    likes: 1567,
    tags: ["Família", "Paternidade", "Emoções"]
  },
  {
    id: 10,
    autor: "L.C.",
    cidade: "Manaus, AM",
    data: "2 de abril de 2024",
    categoria: "carreira",
    trecho: "Você abriu sua própria empresa. Sim, aquele sonho que parecia impossível. Hoje você emprega 15 pessoas e muda vidas. O medo do fracasso quase te impediu, mas a vontade de vencer foi maior. Você é prova de que sonhos se realizam quando há coragem.",
    likes: 1876,
    tags: ["Carreira", "Empreendedorismo", "Sonhos"]
  },
  {
    id: 11,
    autor: "Patricia R.",
    cidade: "Goiânia, GO",
    data: "20 de fevereiro de 2024",
    categoria: "superacao",
    trecho: "Você sobreviveu ao câncer. Cada sessão de quimio, cada lágrima, cada medo valeu a pena. Hoje você celebra 2 anos livre da doença e aprendeu que a vida é preciosa demais para ser desperdiçada com coisas pequenas. Você renasceu.",
    likes: 3124,
    tags: ["Superação", "Saúde", "Gratidão"]
  },
  {
    id: 12,
    autor: "Anônimo",
    cidade: "Florianópolis, SC",
    data: "12 de março de 2024",
    categoria: "amor-proprio",
    trecho: "Você terminou aquele relacionamento tóxico. Doeu? Muito. Mas hoje você respira aliviado. Descobriu que estar sozinho é melhor do que estar mal acompanhado. E o melhor: você se apaixonou por si mesmo primeiro. O amor verdadeiro virá quando você estiver pronto.",
    likes: 2089,
    tags: ["Amor-próprio", "Relacionamentos", "Recomeço"]
  },
  {
    id: 13,
    autor: "Roberto M.",
    cidade: "Campinas, SP",
    data: "7 de abril de 2024",
    categoria: "saude-mental",
    trecho: "Você parou de beber. Foram 15 anos de luta, mas você venceu. Hoje completa 1 ano sóbrio e sua família voltou. Seus filhos te respeitam novamente. Você provou que nunca é tarde para recomeçar e que você é mais forte que qualquer vício.",
    likes: 2567,
    tags: ["Saúde Mental", "Superação", "Família"]
  },
  {
    id: 14,
    autor: "Juliana T.",
    cidade: "Vitória, ES",
    data: "28 de março de 2024",
    categoria: "carreira",
    trecho: "Você voltou a estudar aos 45 anos. Todos disseram que era tarde demais. Hoje você tem seu diploma e trabalha na área dos sonhos. Idade é só um número quando há determinação. Você inspirou seus filhos a nunca desistirem dos próprios sonhos.",
    likes: 1654,
    tags: ["Carreira", "Educação", "Inspiração"]
  },
  {
    id: 15,
    autor: "Anônimo",
    cidade: "João Pessoa, PB",
    data: "16 de fevereiro de 2024",
    categoria: "familia",
    trecho: "Você perdoou. Aquela mágoa que carregava há anos finalmente foi embora. Não foi fácil, mas você entendeu que perdoar não é esquecer, é se libertar. Hoje sua família está reunida novamente e você dorme em paz.",
    likes: 1432,
    tags: ["Família", "Perdão", "Paz"]
  }
];

export const estatisticasGaleria = {
  totalCartas: 3247,
  taxaTransformacao: 97,
  avaliacaoMedia: 4.9,
  usuariosAtivos: 2847
};

export const categorias = [
  { id: "todas", nome: "Todas as Cartas", icone: "ri-mail-line" },
  { id: "superacao", nome: "Superação", icone: "ri-trophy-line" },
  { id: "carreira", nome: "Carreira", icone: "ri-briefcase-line" },
  { id: "amor-proprio", nome: "Amor-próprio", icone: "ri-heart-line" },
  { id: "familia", nome: "Família", icone: "ri-group-line" },
  { id: "saude-mental", nome: "Saúde Mental", icone: "ri-mental-health-line" }
];